import { Link } from 'react-router-dom';
import { useState } from 'react';
import { useCart } from '../../contexts/CartContext';
import CartDrawer from './CartDrawer';

export default function Header() {
  const [isCartOpen, setIsCartOpen] = useState(false);
  const { getItemCount } = useCart();
  const itemCount = getItemCount();

  return (
    <>
      <header className="fixed top-0 left-0 right-0 bg-[#0B1B3A] shadow-sm shadow-black/20 z-50">
        <div className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between">
          <Link to="/" className="text-2xl font-serif text-[#F5F0E8]" style={{ fontFamily: 'Pacifico, serif' }}>
            ig-night
          </Link>
          
          <nav className="hidden md:flex items-center space-x-8">
            <Link to="/" className="text-sm text-[#8A9BB5] hover:text-[#F5F0E8] transition-colors uppercase tracking-wider">
              Home
            </Link>
            <a href="/#collections" className="text-sm text-[#8A9BB5] hover:text-[#F5F0E8] transition-colors uppercase tracking-wider cursor-pointer">
              Destinations
            </a>
            <a href="/#craft" className="text-sm text-[#8A9BB5] hover:text-[#F5F0E8] transition-colors uppercase tracking-wider cursor-pointer">
              Our Craft
            </a>
            <a href="/#story" className="text-sm text-[#8A9BB5] hover:text-[#F5F0E8] transition-colors uppercase tracking-wider cursor-pointer">
              Story
            </a>
          </nav>

          <div className="flex items-center space-x-4">
            <button className="w-10 h-10 flex items-center justify-center hover:bg-[#162D52] rounded-full transition-colors cursor-pointer">
              <i className="ri-search-line text-[#F5F0E8] text-xl"></i>
            </button>
            <button 
              onClick={() => setIsCartOpen(true)}
              className="w-10 h-10 flex items-center justify-center hover:bg-[#162D52] rounded-full transition-colors cursor-pointer relative"
            >
              <i className="ri-shopping-bag-line text-[#F5F0E8] text-xl"></i>
              {itemCount > 0 && (
                <span className="absolute -top-1 -right-1 bg-[#D4C5A9] text-[#0B1B3A] text-xs font-medium w-5 h-5 rounded-full flex items-center justify-center">
                  {itemCount}
                </span>
              )}
            </button>
          </div>
        </div>
      </header>

      <CartDrawer isOpen={isCartOpen} onClose={() => setIsCartOpen(false)} />
    </>
  );
}
